import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from '@stubhub/bamboo';
import TrustMessage from '@stubhub/react-trust-message';

const CollapsibleItem = ({title, info, icon, children}) => (
  <details className="details">
    <summary className="summary">
      <TrustMessage icon={icon} title={title} info={info} />
      <Icon name="ArrowDown" className="chevron" />
    </summary>
    <div className="content">{children}</div>
  </details>
);

CollapsibleItem.propTypes = {
  /** Title of the collapsible item */
  title: PropTypes.node.isRequired,

  /** Info of the collapsible item */
  info: PropTypes.node.isRequired,

  /** Icon of the collapsible item */
  icon: PropTypes.node.isRequired,

  /** Children nodes */
  children: PropTypes.node,
};

export default CollapsibleItem;
